import Drawer from './drawer';

const CountrySelectDrawer = class extends Drawer {
    get shouldAppendToBody() { // eslint-disable-line class-methods-use-this
        return false;
    }
};

export default CountrySelectDrawer;
